import { render } from "./ProductsProductPage.vue?vue&type=template&id=3628531d"
import script from "./ProductsProductPage.vue?vue&type=script&lang=js"
export * from "./ProductsProductPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__